export const ME_CNPJ = '02.351.877/0013-96';
export const ME_NAME = 'LWSA S/A';
